const state = {
	accessToken: ""
};

const mutations = {
	SET_TOKEN: (state, accessToken) => {
		state.accessToken = accessToken;
	}
};

const actions = {
	setToken({
		commit
	}, accessToken) {
		commit("SET_TOKEN", accessToken);
	}
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
};
